window.VH = window.VH === undefined ? {} : window.VH;

VH.Quizz = {
    checkRadioShow : function checkRadioShow(radioContainer) {
        $(radioContainer)
            .find(':checked')
            .closest('label')
            .addClass('list-group-item-success')
            .siblings()
            .removeClass('list-group-item-success');
    },

    init : function init() {
        let _t = VH.Quizz,
            radios = $('.vh-radio');

        radios.on('change', 'input', function() {
            _t.checkRadioShow($(this).closest('.vh-radio'));
        });

        radios.each(function() {
            _t.checkRadioShow(this);
        });
    }
};
